module.exports = __webpack_public_path__ + "img/logo.8310dbd3.png";